import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_blue",
  "use": "icon-icon_blue-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-icon_blue\">\n  <defs>\n    <style>\n      #icon-icon_blue .cls-1 {\n        fill: #1890ff;\n      }\n    </style>\n  </defs>\n  <path id=\"icon-icon_blue_Shape\" class=\"cls-1\" d=\"M7,0a7,7,0,1,0,7,7A7.008,7.008,0,0,0,7,0ZM7,3.5a.437.437,0,1,1,.437-.437A.438.438,0,0,1,7,3.5ZM5.681,6.091a.437.437,0,1,1,0-.875h1.3a.438.438,0,0,1,.437.437V10.5h.889a.438.438,0,1,1,0,.875H5.694a.437.437,0,1,1,0-.875h.848V6.091Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol